export default "__VITE_ASSET__SVGhtYZW__"